// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3462":"6e3ef9da3f8443cb","6368":"ea62fd69226e5b64","9065":"b25b0556ac28ac1a"}[chunkId] + ".js";
};